class ProductMedias extends HTMLElement {
  constructor() {
    super();

    this.swiper = null;
    this.swiperContainer = this;
    this.swiperWrapper = this.querySelector(".product-medias__container");
    this.swiperSlides = this.querySelectorAll(".product-medias img, .product-medias .product-media__video-wrapper");
    this.init();
    window.addEventListener("resize", function() {
      this.init();
    }.bind(this));
  }

  init() {
    this.isPhone = window.innerWidth < 990;
    
    if (this.isPhone) {
      console.log("INIT SWIPER");
      this.initSwiper();
    } else {
      this.destroySwiper();
    }
  }

  initSwiper() {
    console.log("INIT SWIPER");
    if (this.swiper == null) {
      this.swiperContainer.classList.add("swiper");
      this.swiperWrapper.classList.add("swiper-wrapper");

      let paginationDiv = document.createElement("div");
      paginationDiv.classList.add("swiper-pagination");
      this.swiperContainer.appendChild(paginationDiv);

      this.swiperSlides.forEach((slide) => {
        let div = document.createElement("div");
        div.classList.add("swiper-slide", "swiper-slide-item");

        if (this.classList.contains("product-medias--Bracelet")) {
          if (slide.classList.contains("selected")) {
            div.classList.add("selected");
          } else {
            div.classList.remove("swiper-slide");
            div.classList.remove("selected");
            div.classList.add("hidden");
          }
        }
        div.appendChild(slide);
        this.swiperWrapper.appendChild(div);
      });

      this.swiper = new Swiper(this.swiperContainer, {
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: this.querySelector(".swiper-pagination"),
          clickable: true,
        },
        on: {
          slideChange: (swiper) => {
            this.handleVideoPlayback(swiper);
          },
          slideChangeTransitionEnd: (swiper) => {
            this.handleVideoPlayback(swiper);
          },
        },
      });

      setTimeout(() => {
        this.handleVideoPlayback(this.swiper);
      }, 100);
    }
  }

  handleVideoPlayback(swiper) {
    if (!swiper) return;

    const allSlides = swiper.slides;
    allSlides.forEach((slide, index) => {
      const video = slide.querySelector("video");
      if (video) {
        if (index === swiper.activeIndex) {
          video.currentTime = 0;
          video.muted = true;
          video.play().catch((e) => console.log("Video play error:", e));
        } else {
          video.pause();
        }
      }
    });
  }

  destroySwiper() {
    if (this.swiper != null) {
      this.swiper.destroy();
      this.swiper = null;
      for (let i = 0; i < this.classList.length; i++) {
        if (this.classList[i].indexOf("swiper") > -1) {
          this.classList.remove(this.classList[i]);
        }
      }
    }
  }
}

customElements.define("product-medias", ProductMedias);
